export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  Partial<Pick<T, K>>;

export const assertNever = (x: never): never => {
  throw new Error(`Unexpected object: ${x}`);
};

export function isUrl(str: string): boolean {
  try {
    new URL(str);
    return true;
  } catch {
    return false;
  }
}

export function isBase64Image(str: string): boolean {
  return /^data:image\/(png|jpeg|jpg|gif|webp);base64,/.test(str);
}

export function capitalize(str: string | null | undefined) {
  if (!str) {
    return '';
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}
